<template>
  <div class="m750" ref="currentMain">
    <PublicHeader
      letter="N"
      :code="3"
      :value1="id"
      :title="title"
      :imgurl="imgUrl"
      style="z-index:3"
    >
      <div class="openApp">
        打开APP
      </div>
    </PublicHeader>
    <div class="m750main">
 
    <div class="top">
      <div class="rule" @click="showMask(1)"></div>
      <div class="float">
        <!-- <div class="float_item">漂***贝获得奥运纪念徽章</div> -->
        <div class="horselamp_box">
          <div class="horselamp_list" :class="{horselamp_top:animate}">
            <div v-for="(item, index) in logs" :key="index">
            {{getName(item.userName)}}获得{{item.badgeName}}徽章
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 点亮军团 -->
    <div class="center">
      <div class="label"></div>
      <div class="title" style="display:none">徽章用于直播间互动展示</div>
      <div class="group">
        <div class="group_item" v-for="(item,index) in legion" :key="index">
          <div class="group_left">
            <img :src="item.img" alt="">
          </div>
          <div class="group_center">
            <div class="g_top">{{item.name}}</div>
            <div class="g_center">
              <div class="progress">
                <div class="progress_active" v-if="item.lightingNums>0" :style="{width:parseFloat(scale[index]+0.01)+'rem'}"></div>
                <div class="progress_active" v-else :style="{width:scale[index]+'rem'}"></div>
              </div>
              <div class="number">{{handleLNum(item.lightingNums)}} 点亮</div>
            </div>
            <div class="g_bottom" @click="gotodown()"><div>去圈子助威</div><img src="https://images.zhibo.tv/2021/0713/icon_right.png" alt=""></div>
          </div>
          <!-- 还没点亮 -->
          <div class="group_right" v-if="item.hasLight==0" @click="gotodown()"></div>
          <!-- 已经点亮 -->
          <div class="group_right2" v-else></div>
        </div>
      </div>
    </div>
    <!-- 中奖 -->
    <div class="prize">
      <div class="label"></div>
      <div class="title">实物奖励：随机抽取中奖用户</div>
      <div class="prize_center">
        <div class="prize_item" v-for="(item,index) in rewards" :key="index">
          <div class="prize_title">{{item.rewardIssue}}</div>
          <img class="prize_img" :src="item.rewardImg" alt="">
          <div class="prize_win" v-if="item.status==0"  @click="showMask(4,item.id)">查看中奖名单</div>
        </div>
      </div>
    </div>
    <div class="prize_rule">
      <div class="ruletitle">徽章奖励：</div>
      <div class="rulemain">为军团点亮金牌后，立即获得该军团徽章1天并自动佩戴，活动期间累计点亮10天金牌，可获得奥运先锋徽章30天使用权（徽章用于直播间互动展示）</div>
    </div>
    <div class="logo">
      <img class="logoimg" src="https://images.zhibo.tv/2021/0713/logo.png" alt="">
    </div>
    <!-- 弹层 -->
    <div class="mask" v-if="maskShow">
      <div class="mask-layer">
        <div class="mask-content" v-if="rule">
          <div class="close" @click="closeBtn(1)"></div>
          <div class="mask-title">活动说明</div>
          <!-- 规则 -->
          <div class="rule" v-html="rules">
          </div>
          <div class="btn close-btn" @click="closeBtn(1)"></div>
        </div>
        <div class="mask-content mask-prizeMain" v-if="prize">
          <div class="close" @click="closeBtn(4)"></div>
          <div class="mask-title">中奖名单</div>
          <!-- 规则 -->
          <div class="mask-prize">
            <div class="win_main">
              <div class="win_item" v-for="(item,index) in prizeList" :key="index">{{getName(item.userName)}}</div>
            </div>
            <div class="win_tips">
              官方账户“中国体育体育圈”将私信中奖人<br>接收快递信息，请注意查看
            </div>
          </div>
          <div class="btn close-btn" @click="closeBtn(4)"></div>
        </div>
        <div class="mask-dian" v-if="badge">
          <div class="userNews">
            <img class="userImg" :src="userHeadImg" alt="">
          </div>
          <div class="close" @click="closeBtn(2)"></div>
          <div class="sharename">{{userName}}</div>
          <div class="sharemain">
            <div class="badge">
              <img class="badgeimg" src="https://images.zhibo.tv/2021/0713/sharejin2.png" alt="">
            </div>
            <div class="row">
              <img class="rowimg" src="https://images.zhibo.tv/2021/0708/arrow.png" alt="">
            </div>
            <div class="group">
              <img class="groupimg" :src="legionImg" alt="">
              <div class="groupp">{{legionName}}</div>
            </div>
          </div>
          <!-- <div class="dian-title">助力中国奥运军团赢好礼</div>
          <div class="dian-main">
            <div class="badge">
              <img class="badgeimg" src="https://images.zhibo.tv/2021/0708/icon_img.png" alt="">
            </div>
            <div class="row">
              <img class="rowimg" src="https://images.zhibo.tv/2021/0708/arrow.png" alt="">
            </div>
            <div class="group">
              <img class="groupimg" src="https://file.zhibo.tv/uploads/new_upload/image/20210620/20210620201519_18591.jpg" alt="">
              <div class="groupp">乒乓球军团</div>
            </div>
          </div> -->
          <div class="share-text">
                <img
                  src="https://images.zhibo.tv/2021/0713/icon_sup.png"
                  class="sup"
                />
                <div class="dian-title">助力中国奥运军团赢好礼</div>
                <p>您的好友已为{{legionName}}点亮金牌</p>
                <img
                  src="https://images.zhibo.tv/2021/0713/icon_sup.png"
                  class="sub"
                />
              </div>
          <div class="dian-btn" @click="join" v-if="!ishelp"></div>
          <div class="dian-btn overhelp"  v-else @click="closeBtn(2)"></div>
        </div>
      </div>
    </div>
    <!-- 弹层2 -->
    <div class="mask2" v-if="maskShow2">
      <div class="mask-layer">
        <div class="mask-success">
          <div class="success_top">
            <img class="img2" src="https://images.zhibo.tv/2021/0708/icon_img2.png" alt="">
            <img class="imgcon" src="https://images.zhibo.tv/2021/0708/congratulations.png" alt="">
            <div class="success_tips">成功为乒乓球军团点亮金牌</div>
          </div>
          <img class="success_img" src="https://images.zhibo.tv/2021/0708/icon_share.png" alt="">
          <div class="success_explain">
            抽奖结果会在活动首页及时公布，<br>请您留意
          </div>
          <img @click="closeBtn(3)" class="success_close" src="https://images.zhibo.tv/2021/0708/icon_close.png" alt="">
        </div>
      </div>
    </div>
    
    </div>
  </div>
  
</template>

<script>
import PublicHeader from "@/components/PublicHeader";
import ClipboardJS from "clipboard";
import { Toast } from "vant";
export default {
  components: {
    PublicHeader,
  },
  data(){
    return{
      title:'',
      imgUrl:'',
      id:'',
      maskShow: true,
      maskShow2: false,
      rule: false,
      badge: true,
      // 中奖
      rewards: [],
      // 军团
      legion: [],
      // 规则
      rules:'',
      token:'',
      // 点亮记录
      logs: [],
      animate: false,
      prize: false,
      // 中奖名单
      prizeList:[],
      // 计算点亮分母
      denominator:0,
      // 点亮比例
      scale:[],
      // 未助力
      ishelp:false,
      legionId:'',
      gian:'',
      // 要助力的军团图片地址
      legionImg:'',
      // 要助力的军团名称
      legionName:''
    }
  },
  created(){
    document.body.style.overflow = 'hidden'
    document.body.style.height = '100vh'

    this.token = this.$cookies.get("token");
    this.legionId = this.$route.query.legionId; //助力军团id
    this.gain = this.$route.query.gain; // 被助力人房间号

    this.power = this.$cookies.get("roomNum"); //	助力人房间号

    // this.token ="39553d29dd7e3978cbec18772de20d4f*11749056"
    // this.token ="72eff21d88879ac5e7429970aede1d68*4469793"
    // this.token = "aeca4c2a305cddad19c59e5e23d98c4f*160068";
    // this.token = "36fee6c61e29ea7326f12c91fb2930e6*6339507"
    // this.changeStatusbar("#019AAD", 0);
    try {
      window.webkit.messageHandlers.changeTitle.postMessage('助力奥运会')
    } catch (e) {
      window.console.log(0)
    }
    try {
      window.LiveAppJS.changeTitle('助力奥运会')
    } catch (e) {
      window.console.log(1)
    }
    this.getwxShareInfo()
    
    this.getOlympicPowIndex()
    if(this.legionId&&this.gain){
      this.getInfo()
    }else{
      this.maskShow = false
      this.badge = false
      if(this.$refs.currentMain){
        this.$refs.currentMain.style.overflow = 'auto'
      }
    }

    // this.token = "946d4302bb7c6dc0203b0ea3a5ab4dfc*7139627"
    this.getOlympicPowRule()
    this.getOlympicPowerLog()
    // 开启分享按钮
    this.shareInfo()
  },
  methods:{
    // 获取被助力人头像
    async getInfo() {
      const params = {
        roomNum: this.gain,
      };
      const res = await this.$api.getShareUserInfo(params);
      if (res.data.control.status === 200) {
        this.userName = res.data.data.userName;
        this.userHeadImg = res.data.data.userHeadImg;
        this.maskShow = true
        this.badge = true
        this.$refs.currentMain.style.overflow = 'hidden'
      }
    },
    // 助力
    join() {
      if (
        this.token === "" ||
        this.token === null ||
        this.token === undefined
      ) {
        // window.console.log('没登陆')
        this.$router.push({
          name: "login",
          query: {
            path: "shareopower",
            gain: this.gain,
            legionId: this.legionId
          },
        });
      } else {
        if(this.gain==this.power){
          Toast('不能为自己助力')
        }else{
          this.ishelp = true
        }
        // window.console.log('登录')
        // this.getGuessShare();
        
      }
    },
    // 处理微信二次分享
    async getwxShareInfo () {
      const params = {
        url: location.href,
        mp: 1
      }
      const res = await this.$api.getWXshare(params)
      this.appid = res.data.data.appid
      this.timestamp = res.data.data.timestamp
      this.nonceStr = res.data.data.nonceStr
      this.ticket = res.data.data.ticket
      this.url = res.data.data.url
      // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      // this.signature = decodeURIComponent(res.data.data.sign)
      // } else {
      this.signature = res.data.data.sign
      // }
      this.title = '奥运会如约而至，一起来为中国军团点亮金牌，照亮胜利之路！'
      this.imgurl = 'https://images.zhibo.tv/2021/0713/shareimg.png'
      this.desc = '助力中国军团，即可领取军团徽章，更能参加抽奖活动赢得精美礼品！'

      let wx = {}
      const that = this
      if (process.browser) {
        wx = require('weixin-js-sdk')

        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: this.appid, // 必填，公众号的唯一标识
          timestamp: this.timestamp, // 必填，生成签名的时间戳
          nonceStr: this.nonceStr, // 必填，生成签名的随机串
          signature: this.signature, // 必填，签名，见附录1
          ticket: this.ticket,
          jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function () {
          wx.onMenuShareTimeline({ // 分享到朋友圈
            title: that.title, // 分享标题
            link: that.url, // 分享链接
            imgUrl: that.imgurl // 分享图标
          })

          // 分享给朋友
          wx.onMenuShareAppMessage({
            title: that.title,
            desc: that.desc,
            link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: that.imgurl
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert(1, that.title)
            //   alert(2, that.url)
            //   alert(3, that.imgurl)
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享给朋友失败')
            // }
          })
          wx.onMenuShareQQ({ // 分享到QQ
            title: that.title, // 分享标题
            desc: that.desc, // 分享描述
            link: that.url, // 分享链接
            imgUrl: that.imgurl // 分享图标
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert('分享给QQ成功')
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享给QQ失败')
            // }
          })
          wx.onMenuShareWeibo({ // 分享到腾讯微博
            title: that.title, // 分享标题
            desc: that.desc, // 分享描述
            link: that.url, // 分享链接
            imgUrl: that.imgurl // 分享图标
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert('分享到腾讯微博成功')
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享到腾讯微博失败')
            // }
          })
          wx.onMenuShareQZone({ // 分享到QQ空间
            title: that.title, // 分享标题
            desc: that.desc, // 分享描述
            link: that.url, // 分享链接
            imgUrl: that.imgurl // 分享图标
            // success () {
            //   // 用户确认分享后执行的回调函数
            //   alert('分享到QQ空间成功')
            // },
            // cancel () {
            //   // 用户取消分享后执行的回调函数
            //   alert('分享到QQ空间失败')
            // }
          })
        })
      }
    },
    gotodown() {
      this.clipboard();
    },
    clipboard() {
      const that = this;
      const clipboard = new ClipboardJS(".openApp", {
        text() {
          return `${that.letter}:${that.value1}:${that.title}`;
        },
      });
      window.console.log(`${that.letter}:${that.value1}:${that.title}`);
      // window.console.log(`${that.letter}:${that.value1}:${that.title}`)
      clipboard.on("success", function(e) {
        // alert('success')
        window.console.info("Action:", e.action);
        window.console.log("Text:", e.text);
        // alert(e.text)
        window.console.info("Trigger:", e.trigger);
        e.clearSelection();
      });

      clipboard.on("error", function(e) {
        alert("error");
        window.console.log("Action:", e.action);
        window.console.log("Trigger:", e.trigger);
        window.console.log("Text:", e.text);
        alert(e.text);
      });
      window.console.log(clipboard);
      setTimeout(() => {
        this.gotoApp();
      }, 1000);
    },
    gotoApp() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        if (this.$route.name === "atlas-id") {
          location.href = `zhibotv://www.zhibo.tv:80/ios?json={"code":"${this.code}","value1":${this.value1},"value2":"${this.title}","from":"zhibotv"}`;
        } else {
          location.href = `zhibotv://www.zhibo.tv:80/ios?json={"code":"${this.code}","value1":${this.value1},"from":"zhibotv"}`;
        }
      } else if (this.$route.name === "atlas-id") {
        location.href = `zhibotv://www.zhibo.tv:80/android?json={"code":"${this.code}","value1":${this.value1},"value2":"${this.title}","from":"zhibotv"}`;
      } else {
        location.href = `zhibotv://www.zhibo.tv:80/android?json={"code":"${this.code}","value1":${this.value1},"from":"zhibotv"}`;
      }
      setTimeout(() => {
        this.downApply();
      }, 1000);
    },
    downApply() {
      const ua = navigator.userAgent;
      const isAndroid = ua.includes("Android") || ua.includes("Linux");
      const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      const isWeixin = ua.indexOf("MicroMessenger") > 0; // 是否微信
      if (isWeixin) {
        window.location.href =
          "https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile";
      } else if (isAndroid) {
        // window.open('https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile')
        window.location.href =
          "https://android.myapp.com/myapp/detail.htm?apkName=com.seca.live&ADTAG=mobile";
      } else if (isIOS) {
        // window.open('https://apps.apple.com/cn/app/zhi-botv-feng-ge-jiong-yi/id1064012897')
        window.location.href =
          "https://apps.apple.com/cn/app/zhi-botv-feng-ge-jiong-yi/id1064012897";
      }
    },
    // 处理低于10000，按实际数值完整展示 ，例如9879
    // 大于等于10000，以w单位，保留1位小数，例如121200，展示为12.1W
    handleLNum(num){
      if(num>=10000){
        return (num/10000).toFixed(1)+'w'
      }else{
        return num
      }
    },
    // 处理昵称，加密
    getName(name){
      if(name.length==1){
        return name.slice(0,1)+'****'
      }else{
        return name.slice(0,1)+'***'+name.slice(-1)
      }
    },
    // 走马灯 处理
    showhorselamp() {
      this.animate = true;
      // window.console.log(this.logs)
      setTimeout(() => {
        this.logs.push(this.logs[0]);
        this.logs.shift();
        this.animate = false;
      }, 1000);
    },
    // 去圈子
    circlePage(id) {
      // 圈子
      var params = { id }
      try {
        window.webkit.messageHandlers.jumpCirclePage.postMessage(JSON.stringify(params))
      } catch (e) {
        window.console.log('打开圈子失败')
      }
      try {
        window.LiveAppJS.jumpCirclePage(JSON.stringify(params))
      }
      catch (e) {
        window.console.log('打开圈子失败')
      }
    },
    // 启用分享按钮
    shareInfo () {
      // let host = window.location.hostname;
      // let jumpUrl = "https://" + host + "/sparta/#/start?share=1";
      // let jumpUrl = location.href;
      let jumpUrl = this.$address + "static.zhibo.tv/specialtopic/shareopower"

      let imageUrl = "https://images.zhibo.tv/2021/0713/shareimg.png",
        title = "奥运会如约而至，一起来为中国军团点亮金牌，照亮胜利之路！",
        desc = "助力中国军团，即可领取军团徽章，更能参加抽奖活动赢得精美礼品！";
      let param = {
        title: title,
        des: desc,
        imageUrl: imageUrl,
        jumpUrl: jumpUrl
      }
      window.console.log(title, imageUrl, jumpUrl, param)
      try {
        window.webkit.messageHandlers.shareProduct.postMessage(param);
      } catch (e) {
        window.console.log("ios启用分享按钮");
      }
      try {
        window.LiveAppJS.shareProduct(title, desc, imageUrl, jumpUrl);
      } catch (e) {
        window.console.log("Android启用分享按钮");
      }
    },
    // 显示弹窗
    showMask(index,id){
      if(index==1){
        this.rule = true
        this.maskShow = true
        this.$refs.currentMain.style.overflow = 'hidden'
      }else if(index==2){
        this.badge = true
        this.maskShow = true
        this.$refs.currentMain.style.overflow = 'hidden'
      }else if(index==3){
        // 点亮金牌
        // this.badge = false
        if(this.token === "" || this.token === null || this.token === undefined){
          // 没登陆
          // Toast('请先登录')
          try {
            window.webkit.messageHandlers.isnotlogin.postMessage("login");
          } catch (e) {
            window.console.log("");
          }
          try {
            window.LiveAppJS.login();
          } catch (e) {
            window.console.log("");
          }

        }else{
          // 登录了
          this.getOlympicPower(id)
        }
        window.console.log(id)
      }else if(index==4){
        //中奖名单
        this.getOlympicPowerWin(id)
      }
    },
    // 关闭弹窗
    closeBtn(index){
      if(index==1){
        this.rule = false
      }else if(index==2){
        this.badge = false
      }else if(index==3){
        this.maskShow2 = false
      }else if(index==4){
        this.prize = false
      }
      this.maskShow = false
      this.$refs.currentMain.style.overflow = 'auto'
    },
    // 获取数据
    async getOlympicPowIndex(){
      let params = {
        token: this.token
      }
      let res = await this.$api.getOlympicPowIndex(params);
      window.console.log(res);
      this.legion = res.data.data.legion
      this.rewards = res.data.data.rewards
      // this.legion.sort((a,b)=>{
      //   return b.orderNum - a.orderNum
      // })
      // 如果传的军团的id号
      var that = this
      if(this.legionId&&this.gain){
        var data= this.legion.filter(function(item){
          return item.id == that.legionId
        })
        this.legionImg = data[0].img
        this.legionName = data[0].name
        window.console.log(data,this.legionName,this.legionImg); // [{name: "商铺", bianma: "12"}]
      }
      // 军团点亮值的最大值
      let maxNum = this.legion[0].lightingNums;
      for (let i = 0; i < this.legion.length - 1; i++) {
          maxNum = maxNum < this.legion[i+1].lightingNums ? this.legion[i+1].lightingNums : maxNum
      }
      this.denominator = parseFloat((1+0.05)*parseInt(maxNum))
      window.console.log(this.denominator,maxNum,1+0.05,(1+0.05)*parseInt(maxNum))

      for(var i=0;i<this.legion.length;i++){
        this.scale[i] = parseInt(parseFloat(parseInt(this.legion[i].lightingNums)*196)/this.denominator)*0.01
      }
      window.console.log(this.scale)
      // this.legion = this.legion.sort((a,b)=>{
      //   return parseInt(parseInt(b.orderNum) - parseInt(a.orderNum))
      // })
    },
    // 规则
    async getOlympicPowRule(){
      let res = await this.$api.getOlympicPowRule();
      this.rules = res.data.data.content
      this.rules =  this.rules.replace(/style="\/?.+?"/g,"").replace(/ /g,"");
      this.rules =  this.rules.replace(/<br\s*\/?>/g, "<div></div>").replace(/ /g,"");
      // window.console.log(this.rules);
      // this.legion = res.data
    },
    // 点亮金牌
    async getOlympicPower(id){
      let params = {
        token: this.token,
        legionId: id
      }
      let res = await this.$api.getOlympicPower(params);
        window.console.log(res.data.control.status);
      if(res.data.control.status=='200'){
        this.getOlympicPowIndex()
        this.maskShow = false
        this.maskShow2 = true
        this.$refs.currentMain.style.overflow = 'hidden'
      }else{
        Toast(res.data.control.message)
      }
    },
    // 获取点亮记录 前30条
    async getOlympicPowerLog(){
      let params = {
        limit:'30'
      }
      let res = await this.$api.getOlympicPowerLog(params);
      this.logs = res.data.data
      if(this.logs.length>1){
        setInterval(this.showhorselamp, 2000)
      }
      // this.logs = [
      //   {
      //     userName:'啊啊啊啊1'
      //   },
      // ]
      window.console.log(this.logs,res)
    },
    // 中奖名单 记录
    async getOlympicPowerWin(id){
      let params = {
        rewardId: id
      }
      let res = await this.$api.getOlympicPowerWin(params);
      window.console.log(res)
      this.prizeList = res.data.data
      if(this.prizeList.length>0){
        this.prize = true
        this.maskShow = true
        this.$refs.currentMain.style.overflow = 'hidden'
      }
    }
  }
}
</script>

<style lang="less" scoped>
img{ vertical-align:top; outline:none; max-width:100%;}
img{ vertical-align: top; max-width: 100%; outline: 0}
@font-face {
  font-family:YouSheBiaoTiHei;
  src:url('https://images.zhibo.tv/fonts/YouSheBiaoTiHei.ttf');
  font-weight: normal;
  font-style: normal;
}
img{
  object-fit: cover;
}
.m750{
  background:url(https://images.zhibo.tv/2021/0708/power_bg.png) center no-repeat;
  background-size: 100% 100%;
  height: 100%;
  overflow: auto;
  .m750main{
    background:url(https://images.zhibo.tv/2021/0708/power_bg.png) center no-repeat;
    background-size: 100% 100%;
    height: auto;
    overflow: auto;
  }
  .top{
    width: 100%;
    height: 6.02rem;
    background:url(https://images.zhibo.tv/2021/0708/power_head.png) center no-repeat;
    background-size: 100% 100%;
    position: relative;
    margin-top: 1rem;
    .rule{
      width: 1.64rem;
      height: .64rem;
      background:url(https://images.zhibo.tv/2021/0708/power_rule.png) center no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: .4rem;
    }
    .float{
      display: block;
      width: 6rem;
      height: 0.48rem;
      overflow: hidden;
      position: absolute;
      bottom: -0.17rem;
      left: .27rem;
      text-align: center;
      .float_item{
        width: 2.8rem;
        height: .48rem;
        background: rgba(0,25,86,0.5);
        border-radius: .24rem;
        font-size: .2rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8AE0FF;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .horselamp {
        position: absolute;
        bottom: -0.07rem;
        left: .27rem;
        width: 100%;
        height: 50px;
        align-items: center;
        background-color: #ddd;
        display: flex;
        box-sizing: border-box;
      }
      .horselamp_box {
        display: block;
        position: relative;
        // width: 2.8rem;
        height: .48rem;
        background: rgba(0,25,86,0.5);
        border-radius: .24rem;
        overflow: hidden;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
      }
      .horselamp_list {
        display: block;
        // display: flex;
        // flex-direction: column;
        // align-items: self-end;
      }
      .horselamp_top {
        transition: all 1s;
        margin-top: -0.48rem;
      }
      .horselamp_list div {
        // width: 2.8rem;
        height: .48rem;
        // line-height: .48rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .2rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8AE0FF;
        padding: 0 .24rem;
      }
    }
  }
  .center{
    width: 6.9rem;
    // padding: 0 .3rem;
    // height: 7.95rem;
    background: url(https://images.zhibo.tv/2021/0708/power_centerbg.png) center no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    margin: .72rem auto 0;
    position: relative;
    padding-top: .65rem;
    .label{
      width: 3.61rem;
      height: .72rem;
      background: url(https://images.zhibo.tv/2021/0713/haoli.png) center no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: -0.36rem;
      left: 1.65rem;
      z-index: 2;
    }
    .title{
      width: 100%;
      height: .5rem;
      padding-top: .64rem;
      background: url(https://images.zhibo.tv/2021/0708/power_wordbg.png) center no-repeat;
      background-size: 100% 100%;
      font-size: .24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8AE0FF;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .group{
      width: 100%;
      // height: 7rem;
      overflow-y: auto;
      // margin-top: .42rem;
      // padding-top: .65rem;
      .group_item{
        width: 100%;
        height: 1.6rem;
        margin-bottom: .2rem;
        padding: .21rem .3rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .group_left{
          img{
            width: 1.18rem;
            height: 1.18rem;
            display: block;
            border-radius: 50%;
          }
        }
        .group_center{
          width: 3.43rem;
          padding-left: .14rem;
          box-sizing: border-box;
          .g_top{
            font-size: .28rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: .40rem;
            text-shadow: 0px .02rem .15rem #001C60;
          }
          .g_center{
            width: 100%;
            height: .3rem;
            display: flex;
            align-items: center;
            margin-top: .08rem;
            .progress{
              width: 1.96rem;
              height: .1rem;
              background: #001956;
              margin-right: .1rem;
              position: relative;
              .progress_active{
                position: absolute;
                top: 0;
                left: 0;
                height: .1rem;
                background: linear-gradient(255deg, #FF7204 0%, #C30000 100%);
              }
            }
            .number{
              font-size: .22rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #A1E4FF;
            }
          }
          .g_bottom{
            font-size: .24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A1E4FF;
            line-height: .33rem;
            margin-top: .04rem;
            height: .33rem;
            display: flex;
            align-items: center;
            width: 1.42rem;
            img{
              width: .14rem;
              height: .14rem;
              display: block;
              margin-left: .08rem;
              // margin-top: .05rem;
            }
          }
        }
        .group_right{
          width: 1.69rem;
          height: .72rem;
          background: url(https://images.zhibo.tv/2021/0713/dian1.png) center no-repeat;
          background-size: 100% 100%;
        }
        .group_right2{
          width: 1.69rem;
          height: .72rem;
          background: url(https://images.zhibo.tv/2021/0713/dianover1.png) center no-repeat;
          background-size: 100% 100%;
        }
      }
      .group_item:nth-last-child(1){
        margin-bottom: 0rem;
      }
      // &::-webkit-scrollbar {
      //     width: 6px;
      //     height: .6rem;
      //     -webkit-border-radius: 3px;
      //     -moz-border-radius: 3px;
      //     border-radius: 3px;

      // }
      // &::-webkit-scrollbar-thumb {
      //   background-color: #001956;
      //   background-clip: padding-box;
      //   -webkit-border-radius: 3px;
      //   -moz-border-radius: 3px;
      //   border-radius: 5px;
      //   min-height: 28px;
      // }
      // &::-webkit-scrollbar-thumb:hover {
      //   background-color: #001956;
      //   -webkit-border-radius: 3px;
      //   -moz-border-radius: 3px;
      //   border-radius: 3px;
      //   height: .6rem;
      //   width: 6px;
      // }
    }
  }
  .prize{
    margin-top: .8rem;
    .label{
      width: 3.62rem;
      height: .72rem;
      background: url(https://images.zhibo.tv/2021/0713/jiangli.png) center no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .title{
      width: 6.9rem;
      height: .6rem;
      background: url(https://images.zhibo.tv/2021/0708/power_wordbg2.png) center no-repeat;
      background-size: 100% 100%;
      font-size: .26rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8AE0FF;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: .2rem auto 0;
    }
    .prize_center{
      width: 6.9rem;
      // height: 3.38rem;
      // margin-top: .2rem;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0 auto;
      .prize_item{
        width: 2.16rem;
        height: 3.38rem;
        background: url(https://images.zhibo.tv/2021/0713/goodsbg.png) center no-repeat;
        background-size: 100% 100%;
        margin-top: .2rem;
        // padding: .2rem;
        box-sizing: border-box;
        position: relative;
        .prize_win{
          width: 2.16rem;
          height: 3.38rem;
          background: linear-gradient(181deg, rgba(0, 21, 72, 0.43) 0%, #001548 100%);
          font-size: .24rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 0;
          top: 0;
          box-sizing: border-box;
          padding-top: 0.53rem;
        }
        .prize_nowin{
          padding: .2rem;
          box-sizing: border-box;
        }
        .prize_title{
          font-size: .24rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          margin-top: .2rem;
          text-align: center;
        }
        .prize_img{
          width: 1.76rem;
          height: 2.45rem;
          margin: .2rem auto 0;
          display: block;
        }
      }
    }
  }
  .prize_rule{
    width: 6.9rem;
    height: 2.4rem;
    margin: 0 auto;
    background: url(https://images.zhibo.tv/2021/0713/huibg.png) center no-repeat;
    background-size: 100% 100%;
    margin-top: .3rem;
    padding: .3rem;
    box-sizing: border-box;
    .ruletitle{
      font-size: .28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8AE0FF;
      line-height: .4rem;
    }
    .rulemain{
      font-size: .24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8AE0FF;
      line-height: .4rem;
      margin-top: .2rem;
    }
  }
  .logo{
    width: 100%;
    height: 1.53rem;
    box-sizing: border-box;
    .logoimg{
      width: .52rem;
      height: .58rem;
      display: block;
      margin: 1.1rem auto 0;
    }
  }
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: rgba(0, 0, 0, 0.6);
  }
  .mask2 {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background: rgba(0, 0, 0, 0.8);
  }
  .mask-layer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    .mask-dian{
      width: 6.24rem;
      height: 7.51rem;
      background:url(https://images.zhibo.tv/2021/0708/power_bg2.png) center no-repeat;
      background-size: 100% 100%;
      position: relative;
      .userNews{
        width: 1.2rem;
        height: 1.2rem;
        background: linear-gradient(180deg, rgba(48, 184, 249, 1), rgba(10, 117, 236, 1));
        padding: .03rem;
        box-sizing: border-box;
        position: absolute;
        left: 2.52rem;
        top: -0.45rem;
        border-radius: 50%;
        .userImg{
          width: 1.14rem;
          height: 1.14rem;
          box-shadow: 0px .06rem .26rem 0px rgba(10, 20, 51, 0.42);
          // border: .03rem solid;
          // border-image: linear-gradient(180deg, rgba(48, 184, 249, 1), rgba(10, 117, 236, 1)) 3 3;
          display: block;
          position: absolute;
          left:0.03rem;
          top: 0.03rem;
          border-radius: 50%;
        }
      }
      .sharename{
        font-size: .24rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #73E9FF;
        line-height: .32rem;
        text-align: center;
        margin: .9rem auto 0;
      }
      .sharemain{
        width: 4.41rem;
        height: 2.07rem;
        background: url(https://images.zhibo.tv/2021/0713/sharebg.png) center no-repeat;
        background-size: 100% 100%;
        margin: .52rem auto 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .badge{
          width: 1rem;
          height: 1.23rem;
          display: block;
          .badgeimg{
            width: 1rem;
            height: 1.23rem;
            display: block;
            object-fit: contain;
          }
        }
        .row{
          width: .96rem;
          height: .29rem;
          display: block;
          margin-left: .2rem;
          .rowimg{
            width: .96rem;
            height: .29rem;
            display: block;
          }
        }
        .group{
          width: 1.26rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: .05rem;
          .groupimg{
            width: .94rem;
            height: .94rem;
            display: block;
            border-radius: 50%;
          }
          .groupp{
            font-size: .21rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 0.08rem;
            white-space: nowrap;
          }
        }
      }
      .close{
        width: .32rem;
        height: .32rem;
        display: block;
        background: url(https://images.zhibo.tv/2021/0609/icon_close.png) center no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: .29rem;
        right: .38rem;
      }
      .dian-title{
        width: 4.3rem;
        height: .53rem;
        margin: .05rem auto 0;
        font-size: .4rem;
        font-family: YouSheBiaoTiHei;
        color: #FFFFFF;
        line-height: .52rem;
        background: url(https://images.zhibo.tv/2021/0708/wordbg.png)  center no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .dian-main{
        width: 5.48rem;
        height: 2.8rem;
        background: rgba(0, 15, 49, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        margin: .43rem auto 0;
        .badge{
          width: 1.22rem;
          height: 1.54rem;
          img{
            width: 1.22rem;
            height: 1.54rem;
            display: block;
          }
        }
        .row{
          width: 1.19rem;
          height: .36rem;
          display: block;
          margin-left: .25rem;
          .rowimg{
            width: 1.19rem;
            height: .36rem;
            display: block;
          }
        }
        .group{
          width: 1.57rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .groupimg{
            width: 1.18rem;
            height: 1.18rem;
            display: block;
            border-radius: 50%;
          }
          .groupp{
            font-size: .26rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            margin-top: .1rem;
            opacity: 0.9;
          }
        }
      }
      .share-text {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-radius: 0.04rem;
        margin: 0;
        height: 2.23rem;
        // background: #fff;
        font-size: 0.26rem;
        color: #25356c;
        line-height: 0.4rem;
        text-align: center;
      }
      .share-text p {
        font-size: .26rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: .12rem;
      }
      .share-text p:last-of-type {
        padding-bottom: 0;
      }
      .share-text img {
        width: 0.34rem;
      }
      .share-text .mid {
        width: 3.46rem;
      }
      .share-text .sup {
        position: absolute;
        top: 0.38rem;
        left: 0.62rem;
        display: block;
      }
      .share-text .sub {
        position: absolute;
        right: 0.7rem;
        bottom: 0.28rem;
        display: block;
      }
      .dian-rule{
        width: 5.40rem;
        // height: 68px;
        font-size: .22rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: .34rem;
        margin: .44rem auto 0;
        text-align: center;
      }
      .dian-btn{
        width: 3.6rem;
        height: .73rem;
        background: url(https://images.zhibo.tv/2021/0713/sharezhu.png) center no-repeat;
        background-size: 100% 100%;
        margin: .28rem auto 0;
      }
      .overhelp{
        width: 3.6rem;
        height: .73rem;
        background: url(https://images.zhibo.tv/2021/0713/zhuover.png) center no-repeat;
        background-size: 100% 100%;
        margin: .28rem auto 0;
      }
    }
    .mask-success{
      width: 5.9rem;
      height: 8.46rem;
      .success_top{
        width: 5.9rem;
        height: 5.38rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        .img2{
          width: 2.7rem;
          height: 3.06rem;
          display: block;
          margin-top: .87rem;
        }
        .imgcon{
          width: 1.88rem;
          height: .44rem;
          display: block;
          margin-top: .27rem;
        }
        .success_tips{
          font-size: .34rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: .44rem;
          margin-top: .2rem;
          text-align: center;
        }
      }
      .success_img{
        width: 3.6rem;
        height: .72rem;
        display: block;
        margin: .4rem auto 0;
      }
      .success_explain{
        font-size: .2rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #E5E5E5;
        line-height: .34rem;
        text-align: center;
        margin-top: .22rem;
      }
      .success_close{
        width: .46rem;
        height: .46rem;
        display: block;
        margin: .62rem auto 0;
      }
    }
    .mask-prize{
      height: 4.94rem;
      overflow: auto;
      box-sizing: border-box;
      padding: .4rem .42rem .4rem;
      box-sizing: border-box;
      box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 0px 0px rgba(255, 255, 255, 0.1);
      .win_main{
        width: 100%;
        height: 2.88rem;
        overflow: auto;
        .win_item{
          font-size: .28rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: .32rem;
          text-align: center;
          margin-bottom: .32rem;
        }
        .win_item:nth-last-of-type(1){
          margin-bottom: 0rem;
        }
      }
      
      .win_tips{
        font-size: .24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        line-height: .33rem;
        text-align: center;
        margin-top: .6rem;
      }
    }
  }

  .mask-layer .mask-content {
    position: relative;
    width: 6.2rem;
    background: #153E97;
    border-radius: 0.1rem;
  }
  .mask-layer .mask-prizeMain {
    position: relative;
    width: 6.2rem;
    height: 7.02rem;
    background: #153E97;
    border-radius: 0.1rem;
  }
  .mask-layer .mask-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.34rem;
    line-height: 0.44rem;
    color: #73E9FF;
    font-weight: 500;
    height: 1.16rem;
  }
  .mask-layer .close {
    position: absolute;
    width: 0.32rem;
    height: 0.32rem;
    top: 0.32rem;
    right: 0.32rem;
    background: url(https://images.zhibo.tv/2021/0609/icon_close.png) top center
      no-repeat;
    background-size: contain;
    cursor: pointer;
  }
  .mask-layer .close-btn {
    position: absolute;
    left: 50%;
    margin-left: -1.8rem;
    bottom: -0.36rem;
    width: 3.61rem;
    height: .72rem;
    cursor: pointer;
    background: url(https://images.zhibo.tv/2021/0708/power_ok.png) top center
      no-repeat;
    background-size: contain;
  }
  .mask-layer .rule {
    padding: 0.28rem 0.4rem 0;
    height: 6.4rem;
    margin-bottom: 0.84rem;
    box-sizing: border-box;
    overflow: auto;
    box-shadow: 0px -1px 0px 0px rgba(255, 255, 255, 0.1),
      0px 1px 0px 0px rgba(255, 255, 255, 0.1);
  }
  .mask-layer .rule /deep/ div{
    height: .2rem;
  }
  .mask-layer .rule h3 {
    padding-bottom: 0.2rem;
    opacity: 0.9;
    font-size: 0.28rem;
    color: #fff;
    line-height: 0.4rem;
  }
  .mask-layer .rule h4 {
    padding-bottom: 0.2rem;
    font-size: 0.26rem;
    line-height: 0.37rem;
    opacity: 0.9;
    color: #fff;
  }
  .mask-layer .rule /deep/ p {
    // padding-bottom: 0.2rem;
    font-size: 0.24rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 0.33rem;
    strong{
      font-size: .26rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
  .mask-layer .rule /deep/ span {
    // padding-bottom: 0.2rem;
    // opacity: 0.9;
    // font-size: 0.28rem;
    // color: #fff !important;
    // line-height: 0.4rem;
    font-size: .24rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    line-height: .33rem;
  }
}
@supports (bottom: env(safe-area-inset-bottom)){
    .m750{
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom:env(safe-area-inset-bottom); 
    }
}
</style>